const EARTH_RADIUS_MILES = 3958.8;

export const distanceBetweenTwoPoints = (location1, location2) => {
	if (!location1 || !location2) return 0;

	const R = EARTH_RADIUS_MILES;

	const lat1 = parseFloat((parseFloat(location1.lat) * Math.PI) / 180);
	const lng1 = parseFloat((parseFloat(location1.lng) * Math.PI) / 180);

	if (isNaN(lat1) || isNaN(lng1)) return 0;

	const lat2 = parseFloat((parseFloat(location2.lat) * Math.PI) / 180);
	const lng2 = parseFloat((parseFloat(location2.lng) * Math.PI) / 180);

	if (isNaN(lat2) || isNaN(lng2)) return 0;

	const d_lat = lat1 - lat2;
	const d_lng = lng1 - lng2;

	const a =
		Math.pow(Math.sin(d_lat / 2), 2) +
		Math.cos(lat1) * Math.cos(lat2) * Math.pow(Math.sin(d_lng / 2), 2);
	const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

	return c * R;
};
